import React from 'react'
import StackedTagSelect from '../../../../../components/stacked-tag-select/stacked-tag-select'
import { useService } from '@pushly/aqe/lib/hooks/use-service'
import { AppService } from '../../../../../services'
import { PromptGroupPageConditions } from '@pushly/models/lib/structs/prompts/prompt-group-page-conditions'
import { FormLayoutRow } from '@pushly/aqe/lib/components'
import { Form, Space, Typography } from 'antd'

type Props = {
    value?: PromptGroupPageConditions
    onChange: (value: PromptGroupPageConditions) => void
}

const MAX_PAGE_URLS_ALLOWED = 100

function normalizeUrls(val: string[]): string[] {
    return val.map((url) => url.trim())
}

export const PageUrlsConditionEditor: React.FC<Props> = ({ value, onChange }) => {
    const appSvc = useService(AppService)

    const conditions = value ?? new PromptGroupPageConditions()

    return (
        <Space vertical>
            <Typography.Paragraph>
                Enabling this condition will restrict the prompt to a specific group of pages determined by their URL.
            </Typography.Paragraph>

            <Form.Item layout="vertical" label="Show prompt on pages with URLs containing or equal to">
                <StackedTagSelect<string[]>
                    size="medium"
                    mode="tags"
                    placeholder="Page URL or Fragment"
                    maxTagCount={MAX_PAGE_URLS_ALLOWED}
                    getPopupContainer={appSvc.getAppContainer}
                    tokenSeparators={[',']}
                    showOptions={false}
                    defaultValue={conditions.pageUrls ?? []}
                    onChange={(pageUrls) => {
                        const update = conditions.clone()
                        update.pageUrls = normalizeUrls(pageUrls)
                        onChange(update)
                    }}
                    notFoundContent=""
                />
            </Form.Item>

            <Form.Item layout="vertical" label="Do not show prompt on pages with URLs containing or equal to">
                <StackedTagSelect<string[]>
                    size="medium"
                    mode="tags"
                    placeholder="Page URL or Fragment"
                    maxTagCount={MAX_PAGE_URLS_ALLOWED}
                    getPopupContainer={appSvc.getAppContainer}
                    tokenSeparators={[',']}
                    showOptions={false}
                    defaultValue={conditions.excludedPageUrls ?? []}
                    onChange={(excludedPageUrls) => {
                        const update = conditions.clone()
                        update.excludedPageUrls = normalizeUrls(excludedPageUrls)
                        onChange(update)
                    }}
                    notFoundContent=""
                />
            </Form.Item>
        </Space>
    )
}

/* webpack-strip-block:removed */
